import {Typography,} from "@mui/material";
import {ViewPopup} from "components/Admin/Pages/ViewPopup/ViewPopup";
import React from "react";
import {Label} from "../../../components/Label/Label";
import Link from '@mui/material/Link';
import {capService} from "../../../services/capService";
import {useTranslate} from "react-admin";

export const CapView = () => {
  const t = useTranslate();

  return (
    <ViewPopup
      query={capService.getById}
      maxWidth="sm"
    >
      {(record) => (
        <>
          <Typography
            variant="body1"
            gutterBottom
          >
            {record.name}
          </Typography>
          <Typography
            variant="body1"
            sx={{fontWeight: "bold"}}
            gutterBottom
          >
            <Label label="type"/>
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
          >
            {t(`resources.caps.options.type.${record.type}`)}
          </Typography>
          <Typography
              variant="body1"
              sx={{fontWeight: "bold"}}
              gutterBottom
          >
            <Label label="category"/>
          </Typography>
          <Typography
              variant="body1"
              gutterBottom
          >
            {t(`resources.caps.options.category.${record.category}`)}
          </Typography>
          <Typography
            variant="body1"
            sx={{fontWeight: "bold"}}
            gutterBottom
          >
            <Label label="preview"/>
          </Typography>
          <Link href={record?.texture?.albedoTransparency?.src}>
            <img src={record?.texture?.albedoTransparency?.src} alt={record?.texture?.albedoTransparency?.title} style={{height: "256px", width: "256px"}} />
          </Link>
        </>
      )}
    </ViewPopup>
  );
};
